export const identityKeys = {
  root: (hashId?: string | null) => ['opportunities', hashId ?? '', 'identity'] as const,
  persons: (hashId?: string | null) => ['opportunities', hashId ?? '', 'identity', 'persons'] as const,
  children: (hashId?: string | null) => ['opportunities', hashId ?? '', 'identity', 'children'] as const,
  referentials: () => ['identity', 'referentials'] as const,
  consents: (hashId?: string | null) => ['opportunities', hashId ?? '', 'identity', 'consents'] as const,
};
